export const RULES_KEYS: any = {
    matching_rule_type: [
        { value: 'exact_amount_exact_date', label: 'Exact amount and exact date' },
        { value: 'exact_amount_1day', label: 'Exact amount, within ±1 day' },
        { value: 'variance_1day', label: '±X variance allowed, within ±1 day' },
        { value: 'custom', label: 'Custom' }
    ],
    stop_matching: [
        { value: 'after_x_days', label: 'After X days' },
        { value: 'immediate', label: 'Immediately flag if unmatched' }
    ],
    discrepancy_handling: [
        { value: 'manual', label: 'Mark for manual resolution' },
        { value: 'escalate', label: 'Escalate via email if amount exceeds X' }
    ],
    frequency: [
        { value: 'daily', label: 'Daily' },
        { value: 'weekly', label: 'Weekly' },
        { value: 'biweekly', label: 'Bi-weekly' },
        { value: 'monthly', label: 'Monthly' },
        { value: 'manual', label: 'Manual Trigger' }
    ]
}